import * as React from "react";
import Draggable from "./Draggable";

export interface DraggableItem {
  id: string | number;
}

export interface DraggableItems {
  /* tslint:disable:array-type */
  items: Array<DraggableItem | any>;
  setItems: (items: any) => void;
  children?: React.ReactNode;
  component: (item: any) => JSX.Element;
  length: number;
}

const SortableList = ({
  items,
  setItems,
  component,
  length,
}: DraggableItems) => {
  const [dragId, setDragId] = React.useState("");

  const arrayMove = (arr: Array<any>, oldIndex: number, newIndex: number) => {
    if (newIndex >= arr.length) {
      let k = newIndex - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }

    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);

    return arr;
  };

  // const onDrop = (ev: any, item: any) => {
  //   let currentPos = 0;
  //   let droppedPos = 0;

  //   for (let i = 0; i < Object.keys(items).length; i++) {
  //     if (dragId === item) {
  //       currentPos = i;
  //     }
  //     if (ev.currentTarget.id === item) {
  //       droppedPos = i;
  //     }
  //   }

  //   const newItems = arrayMove([...Object.keys(items)], currentPos, droppedPos);

  //   let listItem: any[] = [];

  //   for (const newItem of newItems) {
  //     listItem = [...(listItem || []), ...items[newItem]];
  //   }
  //   setItems(listItem);
  // };

  const onDrop = (ev: any, item: any) => {
    const draggedItemId = dragId;
    const draggedItemIndex = Object.keys(items).indexOf(draggedItemId);
    const droppedItemIndex = Object.keys(items).indexOf(item);

    const itemIds = Object.keys(items);
    const updatedItemIds = arrayMove(itemIds, draggedItemIndex, droppedItemIndex);

    const newListItems: any[] = [];
    for (const newItemId of updatedItemIds) {
      newListItems.push(...items[newItemId]);
    }

    setItems(newListItems);
  };


  const onDragStart = (ev: any, item: any) => {
    setDragId(item);
  };

  const renderComponent = (componentJsx: any, item: any, index: number) => {
    const Component = componentJsx;

    return <Component item={item} index={index} />;
  };

  return (
    <>
      {Object.keys(items).map((item: any, index) => (
        <Draggable
          key={index}
          id={item}
          onDrop={onDrop}
          onDragStart={onDragStart}
          item={item}
          length={length}
        >
          {renderComponent(component, items[item], index)}
        </Draggable>
      ))}
    </>
  );
};

export default SortableList;
